/****************************************************************************************************************
* ©2018 EdgeVerve Systems Limited, Bangalore, India. All Rights Reserved.
*
* The EdgeVerve proprietary software program ("Program"), is protected by copyrights laws, international treaties and
* other pending or existing intellectual property rights in India, the United States and other countries. The Program
* may contain / reference third party or open source components, the rights to which continue to remain with the
* applicable third party licensors or the open source community as the case may be and nothing here transfers the
* rights to the third party and open source components, except as expressly permitted. Any unauthorized reproduction,
* storage, transmission in any form or by any means (including without limitation to electronic, mechanical, printing,
* photocopying, recording or otherwise), or any distribution of this Program, or any portion of it, may result in
* severe civil and criminal penalties, and will be prosecuted to the maximum extent possible under the law.
*****************************************************************************************************************/
import { ViewContainerRef, Input, ViewRef, Output, EventEmitter, ElementRef, OnInit, Directive } from '@angular/core';
import { CommonService } from '../../../services/common.service';
import * as async from 'async';

@Directive()
export abstract class TemplateBaseComponent implements OnInit {

  @Input() viewRef: ViewRef;
  @Input() parentViewRef: ViewContainerRef;
  @Input() templateDraggable: boolean;
  @Input() elementDetail: any;
  @Input() viewOnly: boolean;
  @Input() flexibleTemplate: boolean;
  @Input() dynamicParameters: any;
  @Input() screenId: any;
  @Output() remove = new EventEmitter<any>();
  componentName;

  constructor(
    private commonService: CommonService,
    private elemRef: ElementRef) {
    this.componentName = elemRef.nativeElement.tagName.toLowerCase();
  }

  ngOnInit() {

  }

  constructScreen() {
    var self = this;
    async.eachSeries(this.elementDetail.boxDetails, function (box: any, boxCb) {
      let boxContainerRef = self[box.boxId + 'ViewContainerRef'];
      boxContainerRef.clear();
      if (box.components) {
        async.eachSeries(box.components, function (component: any, componentCb) {
          self.commonService.createDynamicComponent(null, 'dynamic-wrapper', boxContainerRef, function (err, containerRef) {
            if (err) {
              return componentCb(err);
            }
            (<any>containerRef.instance).moduleName = component.module;
            (<any>containerRef.instance).componentName = component.name;
            (<any>containerRef.instance).displayName = component.displayName;
            component.positionId = self.getPositionId(component.positionId, box.boxId);
            (<any>containerRef.instance).positionId = component.positionId;
            if (!self.viewOnly) {
              (<any>containerRef.instance).viewRef = containerRef.hostView;
              (<any>containerRef.instance).parentViewRef = boxContainerRef;
              (<any>containerRef.instance).parentComponents = box.components;
            }
            if (box.fixed) {
              (<any>containerRef.instance).viewOnly = true;
            } else {
              (<any>containerRef.instance).viewOnly = self.viewOnly;
            }
            if (component.staticParameters) {
              (<any>containerRef.instance).staticParameters = component.staticParameters;
            }
            if (self.dynamicParameters) {
              (<any>containerRef.instance).dynamicParameters = self.dynamicParameters;
            }
            (<any>containerRef.instance).remove.subscribe(data => {
              self.removeComponent(data);
            });
            containerRef.changeDetectorRef.detectChanges();
            componentCb();
          });
        }, function (err) {
          boxCb();
        });
      } else {
        boxCb();
      }
    });
  }

  getPositionId(positionId, boxId) {
    return positionId || (this.screenId + '_' + this.componentName + '_' + boxId + '_' + Math.random());
  }

  removeComponent(data) {
    let rIndex = data.parentViewRef.indexOf(data.viewRef)
    data.parentViewRef.remove(rIndex);
    data.parentComponents.splice(rIndex, 1);
  }

  removeElement() {
    this.remove.emit({
      viewRef: this.viewRef,
      parentViewRef: this.parentViewRef
    });
  }

  drag(event) {
    event.dataTransfer.setData("templateComponent", this.componentName);
    if (this.viewRef) {
      event.dataTransfer.setData("dynamicComponent", true);
      var index = this.parentViewRef.indexOf(this.viewRef);
      event.dataTransfer.setData("index", index);
    }
  }

  checkNotFixed(box) {
    for (var boxDetail of this.elementDetail.boxDetails) {
      if (boxDetail.boxId === box) {
        if (boxDetail.fixed) {
          return false;
        } else {
          return true;
        }
      }
    }
    return true;
  }

  dropComponent(event, box) {
    event.preventDefault();
    if (this.viewOnly) {
      return;
    }
    if (event.dataTransfer.getData("templateComponent")) {
      return;
    }

    var components = undefined;
    for (var boxDetail of this.elementDetail.boxDetails) {
      if (boxDetail.boxId === box) {
        if (boxDetail.fixed) {
          return;
        }
        if (!boxDetail.components) {
          boxDetail.components = [];
        }
        components = boxDetail.components;
      }
    }
    if (!components) {
      var detail = {
        boxId: box,
        components: []
      };
      this.elementDetail.boxDetails.push(detail);
      components = detail.components;
    }

    let viewContRef = this[box + 'ViewContainerRef'];

    var ecomponentName = event.dataTransfer.getData("component");
    var moduleName = event.dataTransfer.getData("module");
    var staticParameters = event.dataTransfer.getData("staticParameters");
    var positionId = event.dataTransfer.getData("positionId");
    positionId = this.getPositionId(positionId, box);
    var displayName = event.dataTransfer.getData("displayName");
    if (staticParameters) {
      staticParameters = JSON.parse(staticParameters);
    } else {
      staticParameters = undefined;
    }

    if (!ecomponentName || ecomponentName === "") {
      return;
    }

    var temp = null;
    if (event.dataTransfer.getData("dynamicComponent")) {
      var data = (<any>window).removeData;
      if (data) {
        let rIndex = data.parentViewRef.indexOf(data.viewRef);
        if (!this.flexibleTemplate && data.parentViewRef !== viewContRef) {
          return;
        }
        data.parentViewRef.remove(rIndex);
        temp = data.parentComponents[rIndex];
        data.parentComponents.splice(rIndex, 1);
      }
    }

    var insertIndex = 0;
    var heightSum = 0;
    for (var i = 0; i < viewContRef.length; i++) {
      let height = viewContRef.get(i).rootNodes[0].clientHeight;
      if (event.layerY >= heightSum && event.layerY < heightSum + height) {
        break;
      } else {
        insertIndex++;
        heightSum += height;
      }
    }

    var self = this;

    self.commonService.createDynamicComponent(null, 'dynamic-wrapper', viewContRef, function (err, containerRef) {
      (<any>containerRef.instance).moduleName = moduleName;
      (<any>containerRef.instance).componentName = ecomponentName;
      (<any>containerRef.instance).displayName = displayName;
      (<any>containerRef.instance).positionId = positionId;
      (<any>containerRef.instance).viewRef = containerRef.hostView;
      (<any>containerRef.instance).parentViewRef = viewContRef;
      (<any>containerRef.instance).viewOnly = self.viewOnly;
      (<any>containerRef.instance).parentComponents = components;
      if (staticParameters) {
        (<any>containerRef.instance).staticParameters = staticParameters;
      }
      if (self.dynamicParameters) {
        (<any>containerRef.instance).dynamicParameters = self.dynamicParameters;
      }
      (<any>containerRef.instance).remove.subscribe(data => {
        self.removeComponent(data);
      });
      if (temp) {
        components.splice(insertIndex, 0, temp);
      } else {
        components.splice(insertIndex, 0, {
          module: moduleName,
          name: ecomponentName,
          staticParameters: staticParameters,
          dynamicParameters: self.dynamicParameters,
          displayName: displayName,
          positionId: positionId
        });
      }
    });
  }

  allowDrop(event) {
    event.preventDefault();
  }

  openSelector(boxId: string) {
    var allowedComponents;
    var components;
    for (var boxDetail of this.elementDetail.boxDetails) {
      if (boxDetail.boxId === boxId) {
        allowedComponents = boxDetail.allowedComponents;
        if (!boxDetail.components) {
          boxDetail.components = [];
        }
        components = boxDetail.components;
      }
    }
    let viewContRef = this[boxId + 'ViewContainerRef'];
    var self = this;
    this.commonService.openDialog(
      "Select components",
      allowedComponents,
      function (component) {
        if (component) {
          self.commonService.createDynamicComponent(null, 'dynamic-wrapper', viewContRef, function (err, containerRef) {
            (<any>containerRef.instance).moduleName = component.module;
            (<any>containerRef.instance).componentName = component.name;
            (<any>containerRef.instance).displayName = component.displayName;
            var positionId = self.getPositionId(component.positionId, boxId);
            (<any>containerRef.instance).positionId = positionId;
            (<any>containerRef.instance).viewRef = containerRef.hostView;
            (<any>containerRef.instance).parentViewRef = viewContRef;
            (<any>containerRef.instance).viewOnly = self.viewOnly;
            (<any>containerRef.instance).parentComponents = components;
            if (component.staticParameters) {
              (<any>containerRef.instance).staticParameters = component.staticParameters;
            }
            if (self.dynamicParameters) {
              (<any>containerRef.instance).dynamicParameters = self.dynamicParameters;
            }
            (<any>containerRef.instance).remove.subscribe(data => {
              self.removeComponent(data);
            });
            components.splice(0, 0, {
              module: component.module,
              name: component.name,
              staticParameters: component.staticParameters,
              dynamicParameters: component.dynamicParameters,
              displayName: component.displayName,
              positionId: positionId
            });
          });
        }
      });
  }
}


